import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useUrlPrefix } from '../../lib/useUrlPrefix';

/**
 * The /<orgSlug> route doesn't render its own UI anymore — picking a
 * location is the natural first step, so we skip the intermediate
 * "click here to find a location" page and jump straight there. The
 * LocationsMap component handles the 1-vs-many decision below.
 */
export default function OrgLanding() {
  const { orgSlug } = useParams();
  const prefix = useUrlPrefix();
  const navigate = useNavigate();

  useEffect(() => {
    if (!orgSlug) return;
    navigate(`${prefix}/${orgSlug}/locations`, { replace: true });
  }, [orgSlug, prefix, navigate]);

  return <p className="muted">Loading…</p>;
}
